module.exports =
  capture:
    base: '/webcam/capture/'
    options: '/webcam/capture/options'


// WEBPACK FOOTER //
// ./~/oo-routes/routes/webcam.coffee